export const emptyModel = [
  { Data: '01/01', Item: 'Saldo', Valor: '0' },
  { Data: '02/01', Item: 'Saldo', Valor: '0' },
  { Data: '03/01', Item: 'Saldo', Valor: '0' },
  { Data: '04/01', Item: 'Saldo', Valor: '0' },
];

export const initialState = {
  DIB: { data: '', error: false, loading: false },
  patrocinadora: { data: '', error: false, loading: false },
  perfilInvestimento: { data: {}, error: false, loading: false },
  saudeFinanceira: { data: {}, error: false, loading: false, done: false },
  rentabilidade: { data: {}, error: false, loading: false, done: false },
  beneficiarios: { data: [], error: false, loading: false, done: false },
  simulacaoBeneficio: {
    telaSimulacaoConversao: false,
    tipoRendaMensal: 0,
    percentualRendaMensal: '',
    mesesAposentar: '',
    percentualContribuicao: 0,
    remuneracaoMensal: 0,
    crescimentoSalario: 0,
    remuneracoesAno: 0,
    retornoInvestimento: 0,
    percentualSaque: 0,
    prazoRendaTemporaria: 0,
    percentualrcm: '',
    percentualSaldoVitalicio: '',
    beneficiariosChecked: [],
  },
};
